$( '.media-carousel' ).each( function() {
	const $this = $( this );

	let swiper = new Swiper( this, {
		navigation: {
			nextEl: $this.parents( '.carousel-container' ).find( '.carousel-next' )[ 0 ],
			prevEl: $this.parents( '.carousel-container' ).find( '.carousel-previous' )[ 0 ],
		},
		grabCursor: true,
		slidesPerView: 1,
		loop: true,
	} );
} );

$( '.floor-carousel' ).each( function() {
	const $this = $( this );

	let swiper = new Swiper( this, {
		grabCursor: false,
		slidesPerView: 1,
		spaceBetween: 0,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		loop: false,
		allowTouchMove: false,
		navigation: {
			prevEl: $this.parents( '.floor-carousel-container' ).find( '.carousel-next' )[ 0 ],
			nextEl: $this.parents( '.floor-carousel-container' ).find( '.carousel-previous' )[ 0 ],
		},
		pagination: {
			el: $this.parents( '.floor-carousel-container' ).find( '.floor-bullets' )[ 0 ],
			clickable: true,
			renderBullet: function( index, className ) {
				const title = $this.parents( '.floor-carousel-container' ).find( '.floor-slide' ).eq( index ).attr( 'data-title' );

				return '<div class="floor-bullet h-auto w-full opacity-100 !mx-0 rounded-0 bg-transparent hover:text-rod transition-colors ' + className + '">' + title + '</div>';
			},
		},
		on: {
			slideChange: function() {
				// Update the title on slide change
				const activeIndex = this.activeIndex;
				const title = $this.parents( '.floor-carousel-container' ).find( '.floor-slide' ).eq( activeIndex ).attr( 'data-title' );

				// Update the title in the floor toggle button
				$( '.floor-toggle-button .floor-title' ).html( title + ':' );
			},
		},
	} );

	$this.parents( '.floor-carousel-container' ).find( '.floor-bullet' ).on( 'click', function() {
		toggleFloorOptions();

		$( '.floor-toggle-button .floor-title' ).html( $( this ).html() + ':' );
	} );
} );

$( '.floor-toggle-button' ).on( 'click', function() {
	toggleFloorOptions();
} );

function toggleFloorOptions() {
	$( '.floor-toggle-options' ).slideToggle( 300 );
	$( '.floor-toggle-options-container' ).toggleClass( 'bg-light-beige-2' );
	$( '.floor-toggle-button .icon' ).toggleClass( 'rotate-45' );
}

